module.exports = __webpack_public_path__ + "2d887ef5c5b24c0bb4b59e7f8e31d839.svg";